import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LocalStorageService} from '@mpt-fo/common/core/services/local-storage.service';
import {UserPinModel} from "../../../shared/models/user-pin.model";

@Component({
	selector: 'app-set-business-pin-modal',
	templateUrl: './set-business-pin-modal.component.html',
	styleUrls: ['./set-business-pin-modal.component.scss']
})
export class SetBusinessPinModalComponent implements OnInit {

	@Input() showAsModal = false;
	@Input() dismissible = false;
	@Input() isModal = false;
	@Input() hasMoreThanOneBusiness = false;
	@Input() isLoading = false;
	@Output() pinToUse = new EventEmitter();
	@Output() submitEvent = new EventEmitter();
	@Output() onBackEvent = new EventEmitter();
	@Output() selectedOption = 0;
	@Input() isBusinessPinBlocked = false;
	@Input() isUserBo = false;
	@Input() userPinDetails: UserPinModel;
	@Input() hideUseBusinessPin = false;
	@Input() totalBusinesses = 0;
	isUserLoggedAsBo: boolean = this.localStorage.get('USER_ROLE') === 'MONNIFY_AGENT_MANAGER';


	constructor(private localStorage: LocalStorageService) {
	}


	ngOnInit(): void {
	}

	onSubmit() {
		this.pinToUse.emit(0);
		this.submitEvent.emit();
	}

	onBack() {
		this.onBackEvent.emit();
	}

	updatePinToUse(pin: number) {
		this.pinToUse.emit(pin);
		this.submitEvent.emit();
	}
}
